import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAlert } from 'base/core/selectors';
import { CoreSliceActions } from 'base/core/slice';
import AlertModal from '../alert-modal';

interface Props {
  onSubmit: (type: string) => void;
}

const SuccessOfFaildAlert = ({ onSubmit } : Props) => {
  const dispatch = useDispatch();
  const alert = useSelector(selectAlert);

  const handleCloseAlertModal = () => {
    dispatch(CoreSliceActions.hideAlert());
  };

  const handleSubmit = () => {
    dispatch(CoreSliceActions.hideAlert());
    onSubmit(alert.type);
  };

  return (
    <AlertModal
      open={alert.open}
      onClose={handleCloseAlertModal}
      onSubmit={handleSubmit}
      type={alert.type}
      message={alert.message}
      btnText={alert.btnText}
    />
  );
};

export default SuccessOfFaildAlert;
